import { render, staticRenderFns } from "./SVG-HotelBuilding.vue?vue&type=template&id=4dba4473&scoped=true&"
import script from "./SVG-HotelBuilding.vue?vue&type=script&lang=js&"
export * from "./SVG-HotelBuilding.vue?vue&type=script&lang=js&"
import style0 from "./SVG-HotelBuilding.vue?vue&type=style&index=0&id=4dba4473&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dba4473",
  null
  
)

export default component.exports